import React, { Component } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';
import styles from './Root.scss';
import classNames from 'classnames/bind';
import HomeContainer from './Home/HomeContainer';
import LoginContainer from './Login/LoginContainer';
import AgentsContainer from './Agents/AgentsContainer';
import AgentDetailContainer from './AgentDetail/AgentDetailContainer';
import ReviewFormContainer from './ReviewForm/ReviewFormContainer';

const cx = classNames.bind(styles);

class Root extends Component {
  render() {
    return (
      <div className={cx('root')}>
        <Switch>
          <Route exact path="/" component={HomeContainer} />
          <Route exact path="/login" component={LoginContainer} />
          <Route exact path="/agents" component={AgentsContainer} />
          <Route path="/agents/:agentId" component={AgentDetailContainer} />
          <Route path="/reviews" component={ReviewFormContainer} />
          <Route>
            <Redirect replace to="/" />
          </Route>
        </Switch>
      </div>
    );
  }
}

export default Root;



// WEBPACK FOOTER //
// ./src/components/Root.js